<template>
  <div>
    <q-select
      dense
      outlined
      v-model="subgrupo"
      @filter="filtrarSubgrupo"
      use-input
      class="select"
      input-debounce="500"
      :options="options"
      option-label="nome"
      behavior="menu"
      label-color="grey-6"
      label="Selecione o Subgrupo"
      :bg-color="disable ? 'brand-7' : ''"
      :disable="disable"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhum subgrupo encontrado
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  emits: ["enviarSubgrupo"],
  props: ["grupoUuid", "model", "disable", "normalValue"],
  setup(props, { emit }) {
    const store = useStore();

    const subgrupo = ref(props.model);
    const options = ref([]);

    const listarSubgrupo = async (val) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarSubgrupoGrupo",
          {
            catalogoGrupoUuid: props.grupoUuid,
            nome: val,
            page: 1,
            per_page: 10,
          }
        );
        options.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
        options.value = [];
      }
    };

    watch(
      () => subgrupo.value,
      () => {
        emit("enviarSubgrupo", subgrupo.value);
      }
    );

    watch(
      () => props.grupoUuid,
      () => {
        if (
          props.grupoUuid == "" ||
          props.grupoUuid == undefined ||
          props.grupoUuid == null ||
          props.grupoUuid != subgrupo.value?.catalogoGrupoUuid
        ) {
          subgrupo.value = "";
        }
      }
    );

    return {
      listarSubgrupo,
      options,
      subgrupo,
      filtrarSubgrupo(val, update) {
        listarSubgrupo(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .select {
    font-size: 12px;
  }
}
</style>
